const G_RUNNER_PAYMENTS_COMPLETE_DEEP_LINK = process.env.REACT_APP_G_RUNNER_PAYMENTS_COMPLETE_DEEP_LINK;

const PaymentsSetupComplete = () => {
    window.location.href = G_RUNNER_PAYMENTS_COMPLETE_DEEP_LINK;
    return null;
}

export default PaymentsSetupComplete;